/** mock项目地址 */
export const mockHost =
  'https://data.flutterweb.cn/mock/2293/one-graph-wujiebantu/graphql'

import { aiCompetition } from './aiCompetition'
import { login } from './login'
import { msg } from './msg'
import { user } from './user'
import { integral } from './integral'
import { ai } from './ai'
import { plaza } from './plaza'
import { creatorCenter } from './creator-center'

/** 启用mock的operationName */
export const mockKeys = [
  ...aiCompetition,
  ...login,
  ...msg,
  ...user,
  ...integral,
  ...ai,
  ...plaza,
  ...creatorCenter,
]
